import { LogIn, LogOut, Clock } from 'lucide-react'
import { formatDistanceToNow } from 'date-fns'

export default function CheckinStatusCard({ recentCheckins }) {
  const latest = recentCheckins?.[0]
  const isClockedIn = latest && latest.check_in_time && !latest.check_out_time

  if (!latest) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-4 flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center">
          <Clock className="h-5 w-5 text-gray-400" />
        </div>
        <p className="text-sm text-gray-400">No recent check-ins</p>
      </div>
    )
  }

  const timeAgo = formatDistanceToNow(new Date(isClockedIn ? latest.check_in_time : latest.check_out_time), { addSuffix: true })
  const siteName = latest.site_location?.name || 'Unknown'

  return (
    <div className={`rounded-xl border p-4 flex items-center gap-3 ${isClockedIn ? 'bg-emerald-50 border-emerald-200' : 'bg-white border-gray-200'}`}>
      <div className={`h-10 w-10 rounded-full flex items-center justify-center ${isClockedIn ? 'bg-emerald-500' : 'bg-gray-100'}`}>
        {isClockedIn ? (
          <LogIn className="h-5 w-5 text-white" />
        ) : (
          <LogOut className="h-5 w-5 text-gray-400" />
        )}
      </div>
      <div>
        <p className="text-sm font-medium text-gray-900">
          {isClockedIn ? 'Clocked in' : 'Clocked out'} — {siteName}
        </p>
        <p className="text-xs text-gray-500">{timeAgo}</p>
      </div>
    </div>
  )
}
